import React from "react";
import PropTypes from "prop-types";
import { ReactComponent as ArrowIcon } from "./arrow.svg";
import ArrowContainer from "./ArrowContainer";

const Arrow = props => {
  const { direction } = props;
  return (
    <ArrowContainer direction={direction}>
      <ArrowIcon />
    </ArrowContainer>
  );
};

Arrow.propTypes = {
  direction: PropTypes.number.isRequired
};

export default Arrow;
